import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../../FilesPreviewGallery'
import { WidgetContentItemsList } from '../../WidgetContentItemsList'

function WidgetContentFilesList({
  itemProps,
  items,
  scope,
  titleKey = 'Common.ProfileWidgetDocumentsTitleKey',
  visibleCount,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files: items })

  function handleSuccessDownloadFile() {
    handleAddSuccessNotification(
      'Notification.ProfileWidgetDocumentsSuccessDownload'
    )
  }

  return (
    <>
      <WidgetContentItemsList
        {...restProps}
        itemProps={{
          ...itemProps,
          scope,
          onClick: itemProps?.onClick || handleClickFile,
          onSuccessDownloadFile: handleSuccessDownloadFile,
        }}
        items={items}
        title={t(titleKey, { count: items.length })}
        visibleCount={visibleCount}
      />

      <FilesPreviewGallery
        files={items}
        initActive={activeFileIndex}
        scope={scope}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default WidgetContentFilesList
